import React from 'react';
import "./productDisplay.css"

const ProductsTable = ({ products, accessTokenState, idTokenState, activeTier, handleCustomerPortal  }) => {


  const features = [
    'Price',
    'Calls limit per day',
    'Highlighted text characters limit',
    'Input query characters limit',
    'Models',
    'Output characters limit',
  ];

  function handleSubscribeClick(lookup_key) {
    if (!activeTier.includes("Free") || !activeTier){
      alert(`You already subscribed. Your current subscription needs to end before subscribing again`)
      return
    }

    // Create the JSON data
    let jsonData = JSON.stringify({
      lookup_key: lookup_key,
      id_token: idTokenState
    })

    fetch('https://p9arfzpha0.execute-api.ap-south-1.amazonaws.com/development/create-checkout-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: jsonData
    })
    .then(response => response.json())
    .then(data => {
      window.location.href = data
    })
    .catch(error => console.error('Error:', error));
  }

  return (
    <div style={{justifyContent: 'center', display: 'flex'}}>
    <div className="table-responsive">
      <table className="table table-borderless table-hover">
        <thead className="thead-light">
          <tr>
            <th className='productsTableHeading tableColumnsHeading'></th>
            {products.map((product, index) => (
              <th key={index} className='productsTableHeading tableColumnsHeading'>{product.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {features.map((feature, index) => (
            <tr key={index}>
              <td className='productsTableHeading '><strong>{feature}</strong></td>
              {products.map((product, pIndex) => (
                <td key={pIndex} className=''>{product[feature]}</td>
              ))}
            </tr>
          ))}
          <tr>
            <td></td>
            <td></td>
            <td>
              <button className='btn btn-primary' onClick={() => handleSubscribeClick("markr-standard-lookupkey-v2")}>Subscribe</button>
            </td>
            <td>
              <button className='btn btn-primary' onClick={() => handleSubscribeClick("markr-pro-lookupkey")}>Subscribe</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div className='tableFooter'>
      <i className='extraInfo'>* 1 GPT-4 call = 20 GPT-3.5 calls</i>
      <button className='btn btn-secondary' style={{width: '90px'}} onClick={handleCustomerPortal}>My Plan</button>
      </div>
      
    </div>
    </div>
  );
};

export default ProductsTable;
